<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="modalCheck" id="alert_modal" class="modal-wrap">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_close"></div>
        <div class="header_txt"></div>
        <div class="header_close"></div>
      </div>
      <div class="modal_body">
        <div class="modal_contents" v-html="resultValue"></div>
      </div>
      <div class="modal_footer">
        <div v-if="!doneCheck" class="btn_area">
          <!-- 마이페이지에서 프로필 수정 완료가 아닌 다른 alert을 띄워야하는 경우 -->
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
        </div>
        <div v-else class="btn_area">
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="moveMyPage()"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
// import { deleteToken } from '../api/loginout'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    alertMsg: String,
    isOpen: Boolean,
    doneModi: Boolean,
  },
  emits: ['update:isOpen'],

  setup(props, { emit }) {
    const router = useRouter()

    const resultValue = ref('')
    const modalCheck = ref('')
    const doneCheck = ref('')
    watch(
      () => props.isOpen,
      () => {
        modalCheck.value = props.isOpen
        resultValue.value = props.alertMsg
        doneCheck.value = props.doneModi
      }
    )

    const closeModal = () => {
      emit('update:isOpen', false)
    }
    const moveMyPage = () => {
      emit('update:isOpen', false)
      router.push({ path: '/mypage' })
    }
    return {
      resultValue,
      modalCheck,
      doneCheck,

      closeModal,
      moveMyPage,
    }
  },
}
</script>

<style>
/* dimmed */
.modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
}

.modal-container {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
  border-radius: 1.25rem !important;
  z-index: 5;
}

.modal-container .modal_header {
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
}

.modal-container .modal_header .close_modal {
  display: block !important;
  width: 1rem !important;
  height: 1rem !important;
  z-index: 5;
}

.modal-container .modal_header .close_modal img {
  width: 100%;
  z-index: 5;
}

.modal-container .modal_body {
  margin-bottom: 1.25rem;
  z-index: 5;
}

.modal-container .modal_body .modal_contents {
  text-align: center;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}
.modal-container .modal_body .modal_contents .formatTimer {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  /* font-weight: bold; */
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}

.modal-container .modal_footer .btn_area {
  display: flex;
  gap: 0.5rem;
  z-index: 5;
}

.modal-container .modal_footer .btn_area button,
.modal-container .modal_footer .btn_area div {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 3.25rem;
  font-size: 1rem;
  font-weight: bold;
  z-index: 5;
}

.modal-container .modal_footer .btn_area .confirm_close {
  color: #2d2d2d;
  background-color: #dfdfdf;
  border: 1px solid #dfdfdf;
  z-index: 5;
}
</style>
